import { Breakpoints, Colors } from 'goalsetter-webapp-components';
import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 64px;
  width: 864px;
  padding-bottom: 24px;
  @media (max-width: ${Breakpoints.sm_portal}px) {
    width: 90%;
    padding-top: 16px;
  }
`;

export const SendGoalCardContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  margin-top: 40px;
  gap: 24px;
  @media (max-width: ${Breakpoints.sm_portal}px) {
    flex-direction: column;
  }
`;

export const SendGoalCardDescriptionContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  width: 100%;
`;

export const buttonStyle = {
  width: '180px',
};

export const titleWrapperStyle = { paddingTop: '64px' };
